<template>
  <div class="container bigger-top-margin">
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Subscription</div>
          <div class="card-body">
            <b-card v-if="state.account.me && state.account.me.subscription.active && !state.account.me.subscription.trial" bg-variant="success" text-variant="white" title="Active subscription!" class="subscription-card" style="background-color: #e5f6f3;">
              Your active subscription expires on:<br> <mark>{{ state.account.me.subscription.ends_at | formatDateSubscription }}</mark><br>
              <br><small>*Please note: The date you see is not the exact date when the recurring payment will be processed. We allow a few extra days as a buffer to ensure there is no interruption in your service in case the automatic payment fails.</small><br>
              <br>
              <small>
                Do you have a question about the subscription? Need a refund?<br>
                I'm one e-mail away — support@expense.guide
              </small>
            </b-card>
            <b-card v-if="state.account.me && state.account.me.subscription.trial" bg-variant="warning" text-variant="dark" title="Trial subscription!" class="subscription-card">
              Your trial subscription expires on:<br> <mark>{{ state.account.me.subscription.trial_ends_at | formatDateSubscription }}</mark><br>You can use the button below to subscribe.
            </b-card>
            <b-card v-if="state.account.me && !state.account.me.subscription.active && !state.account.me.subscription.trial" bg-variant="light" text-variant="dark" title="Expired subscription!" class="subscription-card">
              Your subscription is expired! You can use the button below to subscribe.
            </b-card>
            <div v-if="state.account.me && (state.account.me.subscription.trial || !state.account.me.subscription.active)">
              <div class="form-group row mb-0 mt-3">
                <div class="col-md-6 offset-md-3 text-center">
                  <button type="button" class="btn btn-primary" @click.prevent="openPaddleCheckout()">
                    Subscribe
                  </button>
                  <br><br><small>*You will be redirected to the payment processors page.</small><br>
                  <span  style="display:inline-block;width:100%;max-width:130px;margin:10px;">
                    <img src="/img/visa-mastercard.png" alt="Secure Payments Processing"
                         style="display:block;max-width:100%;height:auto;outline:none;border:none;">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Subscription',
  data () {
    return {
      paddleInitialized: false
    }
  },
  computed: {
    ...mapState({
      state: state => state
    })
  },
  mounted () {
    this.$loading.startLoading('fetching-data-from-backend')
    this.getLoggedInUser().then(() => {
      this.$loading.endLoading('fetching-data-from-backend')
      this.initializePaddle()
    }).catch(() => {
      this.$loading.endLoading('fetching-data-from-backend')
    })
  },
  methods: {
    ...mapActions([
      'getLoggedInUser'
    ]),
    initializePaddle () {
      // Check if Paddle is available
      const paddleClientToken = process.env.NODE_ENV === 'production'
        ? 'live_8cea4451b127c342d6cc8e0641e'
        : 'test_51fbc558608d1d4b2a04118f4c1'

      if (typeof window.Paddle !== 'undefined') {
        try {
          if (process.env.NODE_ENV !== 'production') {
            window.Paddle.Environment.set('sandbox')
          }
          window.Paddle.Initialize({
            token: paddleClientToken
          })
          this.paddleInitialized = true
        } catch (error) {
          console.error('Failed to initialize Paddle:', error)
        }
      } else {
        // If Paddle is not loaded yet, wait a bit and try again
        setTimeout(() => {
          this.initializePaddle()
        }, 1000)
      }
    },
    openPaddleCheckout () {
      if (!this.paddleInitialized) {
        console.error('Paddle is not initialized')
        return
      }

      if (!this.state.account.me) {
        console.error('User data not available')
        return
      }

      const paddleProductId = process.env.NODE_ENV === 'production'
        ? 'pri_01jy4t8sdpp6nx1xmgk2n6cacd'
        : 'pri_01jy4sryzf9vm703v1jfj14j9z'

      try {
        window.Paddle.Checkout.open({
          items: [{
            priceId: paddleProductId,
            quantity: 1
          }],
          customer: {
            email: this.state.account.me.email,
            name: this.state.account.me.name
          },
          customData: {
            source: 'expense-guide',
            user_id: this.state.account.me.id,
            subscription_id: 1
          },
          settings: {
            displayMode: 'overlay',
            showAddTaxId: true,
            successUrl: 'https://backend.expense.guide/paddle/thank-you'
          }
        })
      } catch (error) {
        console.error('Failed to open Paddle checkout:', error)
      }
    }
  }
}
</script>

<style>
  .subscription-card{
    border-radius: 0.25rem!important;
  }
  .subscription-card h4{
    margin-top:1.3rem;
    margin-bottom:1rem;
  }
  .subscription-card mark{
    border-radius: 3px;
  }
</style>
